function DiamondPin(){

    this.build();
    resizeCallbacks.push(this);

}

DiamondPin.prototype.build = function(){

    let that = this;

    this.element = document.querySelector('.diamond-container--full');

    if( !this.element || mobileCheck.isMobile )
        return false;

    this.posY = $('.diamond-container--full').offset().top;
    this.height = $('.diamond-container--full').innerHeight();

    this.pin = ScrollTrigger.create({
        trigger: ".diamond-container--full",
        start: 'center center',
        endTrigger: ".is-pined",
        end: "bottom bottom",
        scrub: 1,
        onUpdate: self => {
            gsap.to('.diamond-container--full', { y: window.currentY - that.posY + ( window.innerHeight / 2 ) - ( that.height / 2 ) });
        }
    });

};

DiamondPin.prototype.resize = function(){
    if( this.pin ) {
        this.height = $('.diamond-container--full').innerHeight();
    }else{
        this.build();
    }
};
